import React, { useState, useContext } from "react";
import axios from "axios";
import styled from "styled-components";
import { NotificationManager } from "react-notifications";
import CustomSelect from "components/Input/CustomSelect.js";
import {
  TextInput,
  FloatInput,
} from "components/Input/Index.js";
import Button from "@mui/material/Button";
import { makeStyles } from "@mui/styles";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import UserService from "services/UserService";
import { memberclaim } from "variables/markets";
import { memberclaimStatusDataAdmin } from "variables/lists/markets";
import { putMarketMembershipClaim } from "services/ConfigServices";
import moment from "moment";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: '16px',
      marginTop: "1rem",
      //width: "30ch",
    },
  },
  formControl: {
    margin: 8,
    width: "62ch",
  },
  gridList: {
    width: 330,
    height: 400,
    //marginLeft: "-2rem",
  },
  treeVisible: {
    display: "block",
  },
  treeHidden: {
    display: "none",
  },
  textField: {
    fontSize: "14px",
    fontFamily: '"Source Sans Pro",sans-serif',
    "& .MuiInputBase-input": {
      fontSize: "14px",
      fontFamily: '"Source Sans Pro",sans-serif',
    },
  },
  submitButton: {
    color: "#FFFFFF",
    backgroundColor: "#91C73C",
    fontWeight: "bold",
    display: "block",
    marginTop: "15px",
    marginRight: "auto",
    marginLeft: "0.5rem",
    width: "65ch",
    "&:hover": {
      backgroundColor: "#91C73C",
      boxShadow: "0px 11px 15px -7px rgb(0 0 0 / 20%)",
    },
  },
  submitButtonDisabled: {
    color: "#FFFFFF",
    backgroundColor: "#9798A0",
    fontWeight: "bold",
    display: "block",
    marginTop: "15px",
    marginRight: "auto",
    marginLeft: "0.5rem",
    width: "65ch",
  },
}));

const TreeLabel = styled.div`
  font-size: 14px;
  font-weight: 600;
  opacity: 1;
  font-family: "Source Sans Pro", sans-serif;
`;

function EditClaimStatusDialog(props) {
  const { closeModal, refetch, claim } = props;
  const [status, setStatus] = useState(claim.parameters.status);
  const [rejectioncause, setRejectioncause] = useState(claim.parameters.rejectioncause || "");
  const [amountreceived, setAmountreceived] = useState(claim.parameters.amountreceived || "");
  const [buttonDisabled, setButtonDisabled] = useState(false);

  const handleSubmit = async (event) => {
    updateMarketMembershipClaim(event);
  };

  const handleStatusChange = (event) => { setStatus(event.target.value); };
  const handleRejectioncauseChange = (event) => { setRejectioncause(event.target.value); };
  const handleAmountreceivedChange = (event) => { setAmountreceived(event.target.value); };

  const updateMarketMembershipClaim = async (event) => {
    await axios
      .put(
        putMarketMembershipClaim(claim.id),
        {
          ...claim.parameters,
          status,
          rejectioncause,
          amountreceived,
          enddate : (status === 'payed' || status === 'refused') ? (moment().unix()) * 1000 : "",
        },
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        if (res.status == 200) {
          setNotification("success", "Statut modifié");
        } else setNotification("error", "Une erreur est survenue");
        closeModal();
        refetch();
      })
      .catch((error) => {
        console.log(error);
        setNotification("error", "Une erreur est survenue");
      });
  };

  const setNotification = (status, text) => {
    if (status === "success") {
      NotificationManager.success(text);
    } else {
      NotificationManager.error(text);
    }
  };

  const classes = useStyles();

  return (
    <>
      <form className={classes.root}>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12} lg={12}>

            <div>
              <CustomSelect
                inputTitle={memberclaim.status}
                selectValue={status}
                handleSelectValueChange={handleStatusChange}
                data={memberclaimStatusDataAdmin}
              />
            </div>
            {
              status === 'refused' &&
              <div>
                <TextInput
                  inputTitle={memberclaim.rejectioncause}
                  textInput={rejectioncause}
                  handleTextInputChange={handleRejectioncauseChange}
                  multiline={true}
                  rows={5}
                />
              </div>
            }
            {
              status === 'payed' &&
              <div>
                  <FloatInput
                    inputTitle={memberclaim.amountreceived}
                    floatInput={amountreceived}
                    handleFloatInputChange={handleAmountreceivedChange}
                  />
                </div>
            }
            <Button
              disabled={buttonDisabled}
              className={
                buttonDisabled
                  ? classes.submitButtonDisabled
                  : classes.submitButton
              }
              onClick={() => {
                handleSubmit();
              }}
            >
              Modifier
            </Button>
          </GridItem>
        </GridContainer>
      </form>
    </>
  );
}

export default EditClaimStatusDialog;
